import { useEffect, useState } from "react"
import { Commons } from "../utils/Commons"
import { PermissoesService } from "../services/api/Usuarios/PermissoesService"



export const usePermissoes = (permissoes) => {

    const [listPermissoes, setListPermissoes] = useState([])
    const [isLoadingPerm, setIsLoadingPerm] = useState(true)

    const fetchPermissoes = async () => {
            setIsLoadingPerm(true)
        const data = await PermissoesService.verificaPermissao(permissoes)

        if (data.success) {
            let perm = Commons.filtraPermissoes(data.data)
           // console.log(perm);
            setListPermissoes(perm)
        }
         setIsLoadingPerm(false)

    }
    useEffect(() => {

        fetchPermissoes();
    }, [])

    return { listPermissoes, isLoadingPerm };
}